module.exports = __webpack_public_path__ + "img/logo.9746fe2e.svg";